import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { SMClientService } from "../client/SM-client.service";
import { env } from '../document/core/error-handler/env';
import { ReferenceDataCacheService } from '../commonservice/reference-data-cache.service';

@Injectable({ providedIn: 'root' })

export class UserManagementService {
  multipartHeaders: HttpHeaders;
  urlHeaders: HttpHeaders;
  jsonHeaders: HttpHeaders;
  env: any;

  constructor(
    private http: HttpClient, 
    private stateManagement: SMClientService,
    private referenceDataCache: ReferenceDataCacheService) {
    this.env = env;
    this.multipartHeaders = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    this.urlHeaders = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    this.jsonHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  getUsers(): Observable<any> {
    return  this.referenceDataCache.getUsers();
  }

  getUserRolesPermissions(area?: string) {
    return this.referenceDataCache.getRolesPermissions(area);
  }

  getUserStaffReports(userIdsList: any): Observable<HttpResponse<Blob>> {
    return this.http.post('UserManagement/GetStaffReport', userIdsList, { responseType: 'blob', observe: 'response' });
  }

  getAllRoleBasedUsers(previliageKey, area) {
    return this.http.get<any>('UserManagement/GetAllRoleBasedUsers?previliageKey=' + previliageKey + '&area=' + area);
  }

  getUsersByRoleName(roleName) {
    return this.http.get<any>(`UserManagement/GetUsersByRoleName?roleName=${roleName}`);
  }

  getUserRolesDetails() {
    return this.http.get<any>('UserManagement/GetRolesUserDetail');
  }

  setUserRolesAndPrevileges(payload: FormData) {
    return this.http.post<any>('UserManagement/PostAddRolePrivileges', payload);
  }

  addOrEditRolePrevileges(payload: any) {
    return this.http.post<any>('UserManagement/AddEditRoleandPrivilege', payload);
  }

  getCountries() {
    return this.http.get<any>('UserManagement/GetCountries');
  }

  getStates(countryId: number | string) {
    if (countryId != null && !isNaN(+countryId) && countryId !== undefined) {
      return this.http.get<any>('UserManagement/GetSates/' + countryId);
    } else {
      return EMPTY;
    }
  }

  getTaxAgents() {
    return this.http.get<any>('UserManagement/GetAllTaxAgents')
  }

  getUserByRole(strRole, forceNewState: boolean = false) {
    let state = this.stateManagement.getUserRoles.value;
    if (state.length == 0 || state.map(x => x.role).indexOf(strRole) == -1 || forceNewState) {
      return this.http.get<any>('UserManagement/GetUsersByRoleName?roleName=' + strRole + '');
    } else {
      return this.stateManagement.getUserRoles.asObservable();
    }
  }

  getUsersDisplayInClientOrJob(key) {
    return this.http.get<any>('UserManagement/GetUsersDisplayInClientOrJob?clientOrJob=' + key);
  }

  getContactCountries() {
    if (this.stateManagement.getContactCountries.value == null) {
      return this.http.get<any>('UserManagement/GetCountries');
    } else {
      return this.stateManagement.getContactCountries;
    }
  }

  GetRolesPermissionsByParams() {
   return this.referenceDataCache.getRolesPermissions('TaskBudget');
  }

  GetUsersDetails() {
    return this.http.get<any>('UserManagement/GetUsersDetails');
  }

  getClientJobDetails(roleId) {
    return this.http.get<any>(`UserManagement/GetClientJobDetails?roleId=` + roleId);
  }

  GetUserDetail() {
    return this.http.get<any>('UserManagement/GetUserDetail');
  }

  ChangeUserNotificationStatus(Notification) {
    return this.http.post<any>('UserManagement/ChangeUserNotificationStatus', Notification, { headers: this.jsonHeaders });
  }

  EditUserAddress(useraddr) {
    return this.http.post<any>('UserManagement/EditUserAddress', useraddr, { headers: this.jsonHeaders });
  }

  GetUserDefaultNotification() {
    return this.http.get<any>('UserManagement/GetUserDefaultNotification');
  }

  getUserManagementDetailsById(userId) {
    return this.http.get<any>('UserManagement/GetUser?UserId=' + userId);
  }

  getDeletedUserById(userId: string) {
    return this.http.get<any>(`UserManagement/GetDeletedUser?UserId=${userId}`);
  }

  addUser(userData: any) {
    return this.http.post<any>('UserManagement/PostAddUser', userData, { headers: this.jsonHeaders });
  }

  addUserCost(userCost: any) {
    return this.http.post<any>('UserManagement/PostAddUsercost', userCost, { headers: this.jsonHeaders });
  }

  acitivateUserAccess(userId: any) {
    return this.http.post<any>(`UserManagement/ActivateAccess?UserId=${userId}`, {});
  }

  revokeUserAccess(userId: any) {
    return this.http.post<any>(`UserManagement/RevokeAccess?UserId=${userId}`, {});
  }

  cancelInvite(user: any) {
    return this.http.post<any>(`UserManagement/CancelInvite`, user, { headers: this.jsonHeaders });
  }

  inviteUser(user: any) {
    return this.http.post<any>(`UserManagement/InviteUser`, user, { headers: this.jsonHeaders });
  }

  reinviteUser(user: any) {
    return this.http.post<any>(`UserManagement/ReInviteUser`, user, { headers: this.jsonHeaders });
  }

  getUserCostById(userId: string) {
    return this.http.get<any>(`UserManagement/GetUserCosts?userId=${userId}`);
  }

  getRoles() {
    return this.http.get<any>(`UserManagement/GetRolesByFirm`);
  }

  getEmployeeTypes() {
    return this.http.get<any>(`UserManagement/GetEmployeeTypes`);
  }

  getJobTypes() {
    return this.http.get<any>(`UserManagement/GetJobTypes`);
  }

  addKCUser(userDetails: any) {
    return this.http.post<any>(`${this.env.baseUrl}User/AddKcUser`, userDetails);
  }

  updateKCUser(userDetails: any) {
    return this.http.post<any>(`${this.env.baseUrl}User/UpdateKcUser`, userDetails);
  }

  getUserMetadataConfig() {
    return this.http.get<any>(`UserManagement/GetDefaultMetadataByUser`);
  }

  getUserMetadataDefaultConfig() {
    return this.http.get<any>(`UserManagement/GetUserMetadataDefaults`);
  }

  updateUserMetadataConfig(value: boolean) {
    return this.http.post<any>(`UserManagement/UpdateUserMetadataConfig/${value}`, {});
  }
  
  updateUserMetadata(payload: any) {
    const params = new HttpParams().set('metadataId', payload?.metadataId).set('defaultValue', payload?.defaultValue);
    return this.http.post<any>(`UserManagement/UpdateDefaultMetadataByUser`, null, { params });
  }

  updateUserMetadataFields(payload: any) {
    return this.http.post<any>(`UserManagement/AddEditUserMetadataDefaults`, payload);
  }
}
